
import { gql } from '@apollo/client';

export const CREATE_CLASSRECORD = gql`
mutation CreateClassRecord($studentUserId: Int!, $courseId: Int!) {
  createClassRecord(studentUserId: $studentUserId, courseId: $courseId) {
    id
  }
}`;
